import { Space, Typography, theme } from "antd";
import React from "react";

const { Title } = Typography;
const { useToken } = theme;

export default function PageHeader({ title, className, extra = [], extraClassName }) {
  const { token } = useToken();

  return (
    <div className={`flex col-auto w-full ${className}`}>
      <Title
        level={3}
        className="m-0 font-normal text-[30px]"
        style={{ color: token.colorPageHeader }}
      >
        {title}
      </Title>
      <Space className={`flex-1 justify-end ${extraClassName || "gap-3"}`}>
        {Array.isArray(extra) ? (
          extra.map((item, index) => <React.Fragment key={index}>{item}</React.Fragment>)
        ) : (
          <React.Fragment key="extra">{extra}</React.Fragment>
        )}
      </Space>
    </div>
  );
}
